<script lang="ts">
	import BaseInput from './BaseInput/BaseInput.svelte'

	interface Props {
		label?: string
		value?: string
		size?: 'xs' | 'sm' | 'md'
		isRequired?: boolean
		placeholder?: string
		errorMessage?: string
		showError?: boolean
		onInput?: (value: string) => void
		onBlur?: () => void
	}

	let {
		label = '',
		value = '',
		size = 'sm',
		isRequired = false,
		placeholder = '',
		errorMessage = '',
		showError = false,
		onInput,
		onBlur
	}: Props = $props()
</script>

<BaseInput
	{label}
	{value}
	{size}
	{isRequired}
	{placeholder}
	{errorMessage}
	{showError}
	mask={(input: string) => input.replace(/[^\d.-]/g, '')}
	{onInput}
	{onBlur}
/>
